import store from '../store/index'
import _ from 'underscore'
export const languageManager = {
  methods: {
    activeLanguage: function (field) {
      if (!field) return ''
      if (typeof field !== 'object') return field
      const language =
               store.getters.activeLanguage || navigator.language.split('-')[0]
      const removeFalsy = obj => {
        let newObj = {}
        Object.keys(obj).forEach(prop => {
          if (obj[prop]) {
            newObj[prop] = obj[prop]
          }
        })
        return newObj
      }
      const cleanField = removeFalsy(field)
      return (
        cleanField[language] ||
               cleanField.default ||
               Object.values(cleanField)[0]
      )
    },
    selectedLanguage: function (field) {
      if (!field) return ''
      if (typeof field !== 'object') return field
      const language =
               store.getters.activeLanguage || navigator.language.split('-')[0]
      const removeFalsy = obj => {
        let newObj = {}
        Object.keys(obj).forEach(prop => {
          if (obj[prop]) {
            newObj[prop] = obj[prop]
          }
        })
        return newObj
      }
      const cleanField = removeFalsy(field)
      return (
        cleanField[language] || cleanField.default
      )
    },
    transformObject (object) {
      const keys = _.keys(object)
      return _.object(keys, _.map(object, this.selectedLanguage))
    }
  }
}
